/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_No_Obligation_TextInputs */

const fr_help_no_obligation_text = /** @type {(inputs: Help_No_Obligation_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'ajout d'un réseau suggéré n'est pas systématique. La décision finale reste à la discrétion de l'éditeur.`)
};

const en_help_no_obligation_text = /** @type {(inputs: Help_No_Obligation_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adding a suggested network is not automatic. The final decision remains at the editor's discretion.`)
};

/**
* | output |
* | --- |
* | "Adding a suggested network is not automatic. The final decision remains at the editor's discretion." |
*
* @param {Help_No_Obligation_TextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_no_obligation_text = /** @type {((inputs?: Help_No_Obligation_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_No_Obligation_TextInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_no_obligation_text(inputs)
	return en_help_no_obligation_text(inputs)
});